import AccessibilityIcon from "@mui/icons-material/Accessibility"
import DevicesOtherIcon from "@mui/icons-material/DevicesOther"
import EngineeringIcon from "@mui/icons-material/Engineering"
import HandymanIcon from "@mui/icons-material/Handyman"
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty"
import NoteIcon from "@mui/icons-material/Note"
import SaveIcon from "@mui/icons-material/Save"
import ScienceIcon from "@mui/icons-material/Science"
import SportsScoreIcon from "@mui/icons-material/SportsScore"
import { TaskStep } from "graphql/types"

export const getTextForTaskStep = (taskStep: TaskStep) => {
  switch (taskStep) {
    case TaskStep.ADD_DEVICE:
      return "Device hinzufügen"
    case TaskStep.FUNCTION_TEST:
      return "Funktionstest"
    case TaskStep.TEST_CONFIGURATION:
      return "Testvorbereitung"
    case TaskStep.TEST_FOLLOW_UP:
      return "Test Nachbereitung"
    case TaskStep.NOTE:
      return "Interne Notiz"
    case TaskStep.ENGINEERING:
      return "Engineering"
    case TaskStep.WAITING_TIME:
      return "Wartezeit"
    case TaskStep.HELPER:
      return "Hilfskraft"
    case TaskStep.SAVING:
      return "Speichern"
    default:
      throw new Error(`Unknown task step: ${taskStep}`)
  }
}

export const getTextForTaskStep2 = (taskStep: TaskStep) => {
  switch (taskStep) {
    case TaskStep.ADD_DEVICE:
      return "Devices"
    case TaskStep.FUNCTION_TEST:
      return "Funktionstest"
    case TaskStep.TEST_CONFIGURATION:
      return "Testvorbereitung"
    case TaskStep.TEST_FOLLOW_UP:
      return "Test Nachbereitung"
    case TaskStep.NOTE:
      return "Interne Notiz"
    case TaskStep.ENGINEERING:
      return "Engineering"
    case TaskStep.WAITING_TIME:
      return "Wartezeit"
    case TaskStep.HELPER:
      return "Hilfskraft"
    case TaskStep.SAVING:
      return "Speichern"
    default:
      throw new Error(`Unknown task step: ${taskStep}`)
  }
}

export const getIconForTaskStep = (taskStep: TaskStep) => {
  switch (taskStep) {
    case TaskStep.ADD_DEVICE:
      return <DevicesOtherIcon />
    case TaskStep.FUNCTION_TEST:
      return <ScienceIcon />
    case TaskStep.TEST_CONFIGURATION:
      return <HandymanIcon />
    case TaskStep.NOTE:
      return <NoteIcon />
    case TaskStep.TEST_FOLLOW_UP:
      return <SportsScoreIcon />
    case TaskStep.ENGINEERING:
      return <EngineeringIcon />
    case TaskStep.WAITING_TIME:
      return <HourglassEmptyIcon />
    case TaskStep.HELPER:
      return <AccessibilityIcon />
    case TaskStep.SAVING:
      return <SaveIcon />
    default:
      throw new Error(`Unknown task step: ${taskStep}`)
  }
}

export const onlyOnceTask = [
  TaskStep.ADD_DEVICE,
  TaskStep.TEST_CONFIGURATION,
  TaskStep.TEST_FOLLOW_UP,
]

export const resultTasks = [TaskStep.TEST_FOLLOW_UP]

export const setUpTasks = [TaskStep.TEST_CONFIGURATION]
